import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'

export default class TParameterSetAsItemDM extends Data {
	public static className = 'TParameterSetAsItemDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	RID?: number
	GroupSequenceNumber?: number
	ParameterSequenceNumber?: number
	ParameterId?: number
	ParameterGroupId?: number
	ParameterSetId?: number
	RecordMod?: number
	RecordES?: number
	RecordID?: number
	RecordState?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
}